export default class KvDraw {
  constructor({
    pathAnimation,
    activeClass = 'is-active',
    reverseClass = 'js-kv_reverse',
    speedClassPrefix = 'js-kv_speed_',
    defaultDurationMs = 400,
    pathGroupSelectors = [],
    onKv3Complete = null,
    onAllComplete = null
  }) {
    this.pathAnimation = pathAnimation;
    this.activeClass = activeClass;
    this.reverseClass = reverseClass;
    this.speedClassPrefix = speedClassPrefix;
    this.defaultDurationMs = defaultDurationMs;
    this.pathGroupSelectors = pathGroupSelectors;
    this.onKv3Complete = onKv3Complete;
    this.onAllComplete = onAllComplete;
    this.preparedGroups = [];
  }

  prepare() {
    this.preparedGroups = this.pathGroupSelectors
      .map((selector) => {
        const paths = Array.from(document.querySelectorAll(selector));
        if (!paths.length) {
          return null;
        }

        const dashLens = paths.map((path) => {
          const dash = path.getTotalLength();
          const isReverse = path.classList.contains(this.reverseClass);
          const duration = this.getPathDuration(path);
          this.pathAnimation.applyPathDash(path, {
            dasharray: `${dash} ${dash}`,
            offset: isReverse ? -dash : dash
          });
          path.style.opacity = '0';
          return { dash, isReverse, duration };
        });

        const groupDuration = dashLens.reduce(
          (max, item) => Math.max(max, item.duration),
          this.defaultDurationMs
        );

        return { selector, paths, dashLens, groupDuration };
      })
      .filter(Boolean);
  }

  getPathDuration(path) {
    const speedClass = Array.from(path.classList).find((className) =>
      className.startsWith(this.speedClassPrefix)
    );

    if (!speedClass) {
      return this.defaultDurationMs;
    }

    const value = Number(speedClass.replace(this.speedClassPrefix, ''));
    if (!Number.isFinite(value) || value <= 0) {
      return this.defaultDurationMs;
    }

    return value;
  }

  start() {
    if (!this.preparedGroups.length) {
      return;
    }

    const svgs = new Set();
    this.preparedGroups.forEach((group) => {
      group.paths.forEach((path) => {
        const svg = path.closest('svg');
        if (svg) {
          svgs.add(svg);
        }
      });
    });

    requestAnimationFrame(() => {
      svgs.forEach((svg) => svg.classList.add(this.activeClass));

      let totalDelay = 0;
      this.preparedGroups.forEach((group) => {
        const groupDelay = totalDelay;

        if (group.selector === '.js-kv3' && this.onKv3Complete) {
          window.setTimeout(() => {
            this.onKv3Complete();
          }, groupDelay + group.groupDuration);
        }

        group.paths.forEach((path, pathIndex) => {
          const { dash, isReverse, duration } = group.dashLens[pathIndex];
          path.style.opacity = '1';
          this.pathAnimation.cancelPathAnimations(path);
          path.style.visibility = 'visible';
          const animation = path.animate(
            [
              { strokeDashoffset: isReverse ? dash : -dash },
              { strokeDashoffset: 0 }
            ],
            {
              duration,
              delay: groupDelay,
              easing: 'ease-in-out',
              fill: 'forwards'
            }
          );
          this.pathAnimation.bindAnimationFinish(animation, () => {
            this.pathAnimation.settlePathDash(path, dash);
            this.pathAnimation.showPathLoopLayer(path);
            this.pathAnimation.applyPathStrokeOpacity(path);
            this.pathAnimation.disposePathAnimation(animation);
          });
        });

        totalDelay += group.groupDuration;
      });

      if (this.onAllComplete) {
        this.onAllComplete(totalDelay);
      }
    });
  }
}
